import { render } from "./BuyerTwoColumnLot.vue?vue&type=template&id=1982041d&scoped=true"
import script from "./BuyerTwoColumnLot.vue?vue&type=script&lang=js"
export * from "./BuyerTwoColumnLot.vue?vue&type=script&lang=js"

import "./BuyerTwoColumnLot.vue?vue&type=style&index=0&id=1982041d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1982041d"]])

export default __exports__